import { useTranslation } from 'react-i18next';
import EToolTip from 'components/others/EToolTip';
import type { ServicePreviewRow } from '../model/types';

interface ServicesTransferTableRowProps {
    row: ServicePreviewRow;
    mode: 'preview' | 'result';
    colService: string;
    colCount: string;
    colTeam: string;
    statusOk: string;
    statusFail: string;
    onToggle?: (key: string) => void;
}

const ServicesTransferTableRow = ({
    row,
    mode,
    colService,
    colCount,
    colTeam,
    statusOk,
    statusFail,
    onToggle,
}: ServicesTransferTableRowProps) => {
    const { t } = useTranslation(['Objects']);
    const ns = 'documents.proposal2Warehouse';

    const rowClass =
        mode === 'result'
            ? row.status === 'ok'
                ? 'proposal2warehouse-row-ok'
                : 'proposal2warehouse-row-fail'
            : row.alreadyOnObject
              ? 'proposal2warehouse-row-existing'
              : undefined;

    return (
        <tr className={rowClass}>
            {mode === 'preview' ? (
                <td className="check-cell">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        checked={row.selected}
                        disabled={Boolean(row.alreadyOnObject)}
                        onChange={() => onToggle?.(row.key)}
                    />
                </td>
            ) : null}
            <td className="name" data-label={colService}>
                <div className="fw-medium">{row.itemName}</div>
            </td>
            <td className="count text-end" data-label={colCount}>
                {row.itemCount}
            </td>
            <td className="team" data-label={colTeam}>
                {row.alreadyOnObject ? (
                    <EToolTip title={t(`${ns}.badgeExistingService`)}>
                        <span className="badge bg-light-success text-success">
                            {t(`${ns}.badgeExistingShort`)}
                        </span>
                    </EToolTip>
                ) : row.asOtherExpense ? (
                    <EToolTip title={t(`${ns}.badgeAsOtherExpenseHint`)}>
                        <span className="badge bg-light-secondary text-secondary">
                            {t(`${ns}.badgeAsOtherExpense`)}
                        </span>
                    </EToolTip>
                ) : (
                    row.teamLabel
                )}
            </td>
            {mode === 'result' ? (
                <td className="status">
                    <span
                        className={`badge ${
                            row.status === 'ok'
                                ? 'bg-light-success text-success'
                                : 'bg-light-danger text-danger'
                        }`}
                    >
                        {row.status === 'ok' ? statusOk : statusFail}
                    </span>
                    {row.errorMessage ? (
                        <small className="text-danger d-block mt-1">{row.errorMessage}</small>
                    ) : null}
                </td>
            ) : null}
        </tr>
    );
};

export default ServicesTransferTableRow;
